import { render, staticRenderFns } from "./DailyBoxForm.vue?vue&type=template&id=5d0f5020&scoped=true&"
import script from "./DailyBoxForm.vue?vue&type=script&lang=js&"
export * from "./DailyBoxForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d0f5020",
  null
  
)

export default component.exports